/**
 * Builds the OData predicate for one number filter - a custom property of type Number, or a scalar
 * Ticket column such as TotalTimeSpentMinutes.
 *
 * The operator and the value come from two different places. The operator is in the parent/view
 * filters; the value is read back out of the child filter list, falling back to whatever the saved
 * view carries. Those two lists are populated by different callers and are not guaranteed to agree:
 * the mobile ticket list fetches without passing defaultFilters at all, so the key can be present in
 * one and absent from the other. That has to yield no predicate rather than an exception - a throw
 * here is swallowed by getpaginatedTickets and the whole list comes back empty (#35348).
 *
 * Lives outside TicketQueryHelper only so it can be tested: that module reaches App.tsx through
 * FeatureCache and customPopupHelper, so importing it from a spec pulls in the component tree.
 *
 * Returns undefined when there is no value to compare against, which the caller reads as "this
 * filter contributes nothing".
 */
export const getNumberQuery = (selectedValuesArr: number[], childFiltervalues?: FilterPropsItems[], valuesCustomView?: ValuesCustomView) => {

  const _getQuery = (acc: string, condition: string) => {
    return acc ? acc + ` or ${condition}` : condition;
  };

  const customValuesFromCustomView = valuesCustomView?.CustomValues ?? {};

  let query;
  const cpDateKey = Object.keys(customValuesFromCustomView)?.at(0) ?? "";
  const num = childFiltervalues?.find(x => x.key == cpDateKey)?.values?.find(x => x.selected)?.number;
  let viewNum = customValuesFromCustomView[cpDateKey];

  if (num || viewNum) {
    query = selectedValuesArr.reduce((acc: string, current: any) => {
      switch (current) {
        case 0:
          acc = _getQuery(acc, `${cpDateKey} eq ${num ?? viewNum}`);
          break;
        case 1:
          acc = _getQuery(acc, `${cpDateKey} ne ${num ?? viewNum}`);
          break;
        case 2:
          acc = _getQuery(acc, `${cpDateKey} lt ${num ?? viewNum}`);
          break;
        case 3:
          acc = _getQuery(acc, `${cpDateKey} le ${num ?? viewNum}`);
          break;
        case 4:
          acc = _getQuery(acc, `${cpDateKey} gt ${num ?? viewNum}`);
          break;
        case 5:
          acc = _getQuery(acc, `${cpDateKey} ge ${num ?? viewNum}`);
          break;
        default: break;
      }
      return acc;
    }, '');
  }
  return query;
};
